import React, { useMemo } from "react";
import { PageRenderer, RendererRuntimeProvider } from "@apa/core-renderers";
import { usePageHeader } from "../hooks/usePageHeader";
import { createRuntimeImageComponent } from "../Helper/storage";
import { COMPONENT_PREVIEWS } from "./designLibraryPreviews";

const DESIGN_PREVIEW_MAX_WIDTH = 1280;

/** Visual page component library with real-time rendered preview. */
const DesignLibrary: React.FC = () => {
	usePageHeader({ title: "Design Library" });

	const runtimeImageComponent = useMemo(() => createRuntimeImageComponent(), []);
	const runtimeValue = useMemo(
		() => ({
			disableLinks: true,
			imageComponent: runtimeImageComponent
		}),
		[runtimeImageComponent]
	);



	const previewCss = `
    .design-preview {
      max-width: ${DESIGN_PREVIEW_MAX_WIDTH}px;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
    }
    .design-preview section {
      margin-left: 0 !important;
      margin-right: 0 !important;
      max-width: ${DESIGN_PREVIEW_MAX_WIDTH}px !important;
    }
    .design-preview section[class*="mx-[calc(50%-50vw)"] {
      margin-left: auto !important;
      margin-right: auto !important;
      max-width: ${DESIGN_PREVIEW_MAX_WIDTH}px !important;
      width: 100% !important;
    }
    .design-preview section .max-w-7xl {
      max-width: ${DESIGN_PREVIEW_MAX_WIDTH}px;
    }
  `;

	return (
		<div className="space-y-6">
			<style>{previewCss}</style>


			<RendererRuntimeProvider value={runtimeValue}>
				<div className="space-y-6">
					{COMPONENT_PREVIEWS.map((preview) => (
						<article key={preview.id} className="space-y-5">
							<header className="pt-4 pb-4 mt-4 flex items-center justify-center ">
								<p className="text-lg font-semibold uppercase tracking-[0.2em] text-slate-700 text-center">{preview.title}</p>
							</header>
							<div className="mt-4 border border-slate-200 m-8">
								<div
									className="design-preview mx-auto w-full overflow-hidden"
									style={{ maxWidth: `${DESIGN_PREVIEW_MAX_WIDTH}px`, width: "100%" }}
								>
									<PageRenderer components={preview.components} />
								</div>
							</div>
						</article>
					))}
				</div>
			</RendererRuntimeProvider>
		</div>
	);
};

export default DesignLibrary;
